(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient', '../model/Nothing', '../model/App', '../model/Category', '../model/CategoryCreationRequest', '../model/SearchResult', '../model/CategoryUpdateRequest'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/Nothing'), require('../model/App'), require('../model/Category'), require('../model/CategoryCreationRequest'), require('../model/SearchResult'), require('../model/CategoryUpdateRequest'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.VappstoreApi = factory(root.SmartCsV2Sdk.ApiClient, root.SmartCsV2Sdk.Nothing, root.SmartCsV2Sdk.App, root.SmartCsV2Sdk.Category, root.SmartCsV2Sdk.CategoryCreationRequest, root.SmartCsV2Sdk.SearchResult, root.SmartCsV2Sdk.CategoryUpdateRequest);
  }
}(this, function(ApiClient, Nothing, App, Category, CategoryCreationRequest, SearchResult, CategoryUpdateRequest) {
  'use strict';

  /**
   * Vappstore service.
   * @module api/VappstoreApi
   * @version 2.0.624
   */

  /**
   * Constructs a new VappstoreApi. 
   * @alias module:api/VappstoreApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use, default to {@link module:ApiClient#instance}
   * if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the addAppToAccount operation.
     * @callback module:api/VappstoreApi~addAppToAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add an existing app to a specific user&#39;s account
     * @param {String} id 
     * @param {module:api/VappstoreApi~addAppToAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.addAppToAccount = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling addAppToAccount";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/appstore/me/{id}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the addAppToStore operation.
     * @callback module:api/VappstoreApi~addAppToStoreCallback
     * @param {String} error Error message, if any.
     * @param {module:model/App} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add an app to the app store
     * @param {File} appUploadRequest 
     * @param {module:api/VappstoreApi~addAppToStoreCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/App}
     */
    this.addAppToStore = function(appUploadRequest, callback) {
      var postBody = null;

      // verify the required parameter 'appUploadRequest' is set
      if (appUploadRequest == undefined || appUploadRequest == null) {
        throw "Missing the required parameter 'appUploadRequest' when calling addAppToStore";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'appUploadRequest': appUploadRequest
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = App;

      return this.apiClient.callApi(
        '/v2/appstore', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the addPrivateApp operation.
     * @callback module:api/VappstoreApi~addPrivateAppCallback
     * @param {String} error Error message, if any.
     * @param {module:model/App} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Add a private app to a users account
     * @param {File} appUploadRequest 
     * @param {module:api/VappstoreApi~addPrivateAppCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/App}
     */
    this.addPrivateApp = function(appUploadRequest, callback) {
      var postBody = null;

      // verify the required parameter 'appUploadRequest' is set
      if (appUploadRequest == undefined || appUploadRequest == null) {
        throw "Missing the required parameter 'appUploadRequest' when calling addPrivateApp";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'appUploadRequest': appUploadRequest
      };

      var authNames = [];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = App;

      return this.apiClient.callApi(
        '/v2/appstore/me', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the createCategory operation.
     * @callback module:api/VappstoreApi~createCategoryCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Category} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Create a category
     * @param {module:model/CategoryCreationRequest} categoryCreationRequest 
     * @param {module:api/VappstoreApi~createCategoryCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Category}
     */
    this.createCategory = function(categoryCreationRequest, callback) {
      var postBody = categoryCreationRequest;

      // verify the required parameter 'categoryCreationRequest' is set
      if (categoryCreationRequest == undefined || categoryCreationRequest == null) {
        throw "Missing the required parameter 'categoryCreationRequest' when calling createCategory";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Category;

      return this.apiClient.callApi(
        '/v2/appstore/categories', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteAppFromAccount operation.
     * @callback module:api/VappstoreApi~deleteAppFromAccountCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Remove an app from specific user&#39;s account.
     * If it is a private app it will be deleted.
     * @param {String} id 
     * @param {module:api/VappstoreApi~deleteAppFromAccountCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteAppFromAccount = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteAppFromAccount";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/appstore/me/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteCategory operation.
     * @callback module:api/VappstoreApi~deleteCategoryCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete a category
     * @param {String} id 
     * @param {module:api/VappstoreApi~deleteCategoryCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deleteCategory = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deleteCategory";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/appstore/categories/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the deletePublicApp operation.
     * @callback module:api/VappstoreApi~deletePublicAppCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Delete an app
     * @param {String} id 
     * @param {module:api/VappstoreApi~deletePublicAppCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.deletePublicApp = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling deletePublicApp";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/appstore/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getApp operation.
     * @callback module:api/VappstoreApi~getAppCallback
     * @param {String} error Error message, if any.
     * @param {module:model/App} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get data for a single app
     * @param {String} id 
     * @param {module:api/VappstoreApi~getAppCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/App}
     */
    this.getApp = function(id, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling getApp";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = App;

      return this.apiClient.callApi(
        '/v2/appstore/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getAppsForUser operation.
     * @callback module:api/VappstoreApi~getAppsForUserCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SearchResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get apps added to a specific user&#39;s account
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.platform 
     * @param {String} opts.category 
     * @param {String} opts.search 
     * @param {module:model/String} opts.locale 
     * @param {Integer} opts.updatedAfter 
     * @param {module:model/String} opts.industry 
     * @param {String} opts.packageName 
     * @param {Integer} opts.appSize 
     * @param {String} opts.appVersion 
     * @param {Integer} opts.minSdkVersion 
     * @param {Integer} opts.versionCode 
     * @param {Integer} opts.limit 
     * @param {String} opts.nextPageToken 
     * @param {String} opts.sortBy 
     * @param {module:api/VappstoreApi~getAppsForUserCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/SearchResult}
     */
    this.getAppsForUser = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'platform': this.apiClient.buildCollectionParam(opts['platform'], 'csv'),
        'category': opts['category'],
        'search': opts['search'],
        'locale': opts['locale'],
        'updatedAfter': opts['updatedAfter'],
        'industry': opts['industry'],
        'packageName': opts['packageName'],
        'appSize': opts['appSize'],
        'appVersion': opts['appVersion'],
        'minSdkVersion': opts['minSdkVersion'],
        'versionCode': opts['versionCode'],
        'limit': opts['limit'],
        'nextPageToken': opts['nextPageToken'],
        'sortBy': opts['sortBy']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SearchResult;

      return this.apiClient.callApi(
        '/v2/appstore/me', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getCategories operation.
     * @callback module:api/VappstoreApi~getCategoriesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/Category>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all categories
     * @param {module:api/VappstoreApi~getCategoriesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {Array.<module:model/Category>}
     */
    this.getCategories = function(callback) {
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [Category];

      return this.apiClient.callApi(
        '/v2/appstore/categories', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the getPublicApps operation.
     * @callback module:api/VappstoreApi~getPublicAppsCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SearchResult} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get all public apps
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.platform 
     * @param {String} opts.category 
     * @param {String} opts.search 
     * @param {module:model/String} opts.locale 
     * @param {Integer} opts.updatedAfter 
     * @param {module:model/String} opts.industry 
     * @param {String} opts.packageName 
     * @param {Integer} opts.appSize 
     * @param {String} opts.appVersion 
     * @param {Integer} opts.minSdkVersion 
     * @param {Integer} opts.versionCode 
     * @param {Integer} opts.limit 
     * @param {String} opts.nextPageToken 
     * @param {String} opts.sortBy 
     * @param {module:api/VappstoreApi~getPublicAppsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/SearchResult}
     */
    this.getPublicApps = function(opts, callback) {
      opts = opts || {};
      var postBody = null;


      var pathParams = {
      };
      var queryParams = {
        'platform': this.apiClient.buildCollectionParam(opts['platform'], 'csv'),
        'category': opts['category'],
        'search': opts['search'],
        'locale': opts['locale'],
        'updatedAfter': opts['updatedAfter'],
        'industry': opts['industry'],
        'packageName': opts['packageName'],
        'appSize': opts['appSize'],
        'appVersion': opts['appVersion'],
        'minSdkVersion': opts['minSdkVersion'],
        'versionCode': opts['versionCode'],
        'limit': opts['limit'],
        'nextPageToken': opts['nextPageToken'],
        'sortBy': opts['sortBy']
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SearchResult;

      return this.apiClient.callApi(
        '/v2/appstore', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateApp operation.
     * @callback module:api/VappstoreApi~updateAppCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing app
     * @param {String} id 
     * @param {File} appUpdateRequest 
     * @param {module:api/VappstoreApi~updateAppCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.updateApp = function(id, appUpdateRequest, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateApp";
      }

      // verify the required parameter 'appUpdateRequest' is set
      if (appUpdateRequest == undefined || appUpdateRequest == null) {
        throw "Missing the required parameter 'appUpdateRequest' when calling updateApp";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'appUpdateRequest': appUpdateRequest
      };

      var authNames = ['oauth2'];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/appstore/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updateCategory operation.
     * @callback module:api/VappstoreApi~updateCategoryCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Category} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing category&#39;s priority
     * @param {String} id a valid category id.
     * @param {module:model/CategoryUpdateRequest} categoryUpdateRequest Priority-setting request. Data type: integer; Allowed update: SET, UNSET
     * @param {module:api/VappstoreApi~updateCategoryCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Category}
     */
    this.updateCategory = function(id, categoryUpdateRequest, callback) {
      var postBody = categoryUpdateRequest;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updateCategory";
      }

      // verify the required parameter 'categoryUpdateRequest' is set
      if (categoryUpdateRequest == undefined || categoryUpdateRequest == null) {
        throw "Missing the required parameter 'categoryUpdateRequest' when calling updateCategory";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
      };

      var authNames = ['oauth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Category;

      return this.apiClient.callApi(
        '/v2/appstore/categories/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the updatePrivateApp operation.
     * @callback module:api/VappstoreApi~updatePrivateAppCallback
     * @param {String} error Error message, if any.
     * @param {module:model/Nothing} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update an existing private app
     * @param {String} id 
     * @param {File} appUpdateRequest 
     * @param {module:api/VappstoreApi~updatePrivateAppCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {module:model/Nothing}
     */
    this.updatePrivateApp = function(id, appUpdateRequest, callback) {
      var postBody = null;

      // verify the required parameter 'id' is set
      if (id == undefined || id == null) {
        throw "Missing the required parameter 'id' when calling updatePrivateApp";
      }

      // verify the required parameter 'appUpdateRequest' is set
      if (appUpdateRequest == undefined || appUpdateRequest == null) {
        throw "Missing the required parameter 'appUpdateRequest' when calling updatePrivateApp";
      }


      var pathParams = {
        'id': id
      };
      var queryParams = {
      };
      var headerParams = {
      };
      var formParams = {
        'appUpdateRequest': appUpdateRequest
      };

      var authNames = [];
      var contentTypes = ['multipart/form-data'];
      var accepts = ['application/json'];
      var returnType = Nothing;

      return this.apiClient.callApi(
        '/v2/appstore/me/{id}', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
